import $ from 'jquery';

import { getIframe, stringToHTML } from '../../helpers';
import { isEmpty } from '../../utils/common';

const setModalContent = (title, message, id) => {
  title ? (getIframe().getElementById(`${id}_title`).innerText = title) : null;
  getIframe().getElementById(`${id}_message`).innerText = message;
};

const setCallback = (call, id) => {
  getIframe().getElementById(`${id}_commit`).onclick = () => {
    getIframe().getElementById(`alert-modal-fade`).remove();

    //도큐먼트에 fade 생기는 항목 삭제
    $(`body`).find(`.modal-backdrop`).remove();

    if (call) {
      call();
    }
  };

  $(`iframe`)
    .contents()
    .find(`#${id}`)
    .on('click', (e) => {
      // 1. 얼럿 이외의 영역 클릭시
      if (e.target.className.includes('c_modal')) {
        const backdropList = $(`iframe`).contents().find('.modal-backdrop');
        if (backdropList.length > 0) {
          for (let i = 0; i < backdropList.length; i++) {
            if (!isEmpty($(`iframe`).contents().find('.modal-backdrop')[i])) {
              $(`iframe`).contents().find('.modal-backdrop')[i].remove();
            }
          }
        }
      } else {
        // 2. 얼럿 내부 클릭시
        return;
      }
    });
};

export const showAlertModal = (
  title,
  message,
  call = () => {},
  id = 'alert_modal'
) => {
  setModalContent(title, message, id);
  setCallback(call, id);

  $(`iframe`).contents().find(`#${id}`).modal('show');
  $(`iframe`)
    .contents()
    .find('body')
    .append('<div class="modal-backdrop show" id="alert-modal-fade" ></div>');
};

//alertModal 공통 팝업
export const setAlertModal = (showCancel = false, id = 'alert_modal') => {
  let button = `<button type="button" class="btn c_btn1 skin1_btn2" id="${id}_commit" data-dismiss="modal" >확인</button>`;

  if (showCancel) {
    button = `<button type="button" class="btn c_btn3 skin1_btn1" id="${id}_cancel" data-dismiss="modal" >취소</button>
                <button type="button" class="btn c_btn4 skin1_btn2" id="${id}_commit" data-dismiss="modal" >확인</button>`;
  }

  const html = `<div class="modal fade c_modal show" id="${id}">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="${id}_title">알림</h5>
            </div>
            <div class="modal-body">
                <div class="c_label6_4" id="${id}_message">메세지</div>
            </div>
            <div class="modal-footer" >
                ${button}
            </div>
        </div>
    </div>
</div>`;

  stringToHTML(html).children[0].appendAfter(
    getIframe().getElementById('layer-wrapper')
  );

  if (showCancel) {
    getIframe().getElementById(`${id}_cancel`).onclick = () => {
      getIframe().getElementById(`alert-modal-fade`).remove();

      //도큐먼트에 fade 생기는 항목 삭제
      $(`body`).find(`.modal-backdrop`).remove();
    };
  }
};
